export default "__VITE_ASSET__23f35b51__"